import { ConversationViewModelWithLabels } from '../../../comment/models/conversation.model';

export const EXAMPLE_NOTES: ConversationViewModelWithLabels[] = [
  {
    createdBy: 'lars.bjornsson@starkcapital.com',
    createdAt: '2023-09-08T15:05:57.503Z',
    labels: [{ id: 'label-prio-important' }, { id: 'label-investor-contoso' }],
    context: {
      cellValue: {
        type: 'paragraph',
        value: [
          {
            html: `
            <p id="p247" style="padding-left:.58in" domorder="166" class="df190 yellowMarker" data-m-idx="165" data-m-outline-index="16"><span style="display:inline;width:1.25in"><span class="dref" dtid="dt190" refersto="Non-Call Period">Non-Call Period</span> </span><mark class="e_datelogic first last" r="approved">During</mark> the period <span class="e_inlinenum first last">(i)</span> in respect of the <span class="dref" dtid="dt28" refersto="Debt">Debt</span> (<mark class="e_legal-key first last" r="approved">other than</mark> the <span class="dref" dtid="dt625" refersto="Class F Notes">Class F Notes</span>), <mark class="e_datelogic first last" r="approved">from and including</mark> the <span class="dref" dtid="dt31" refersto="Issue Date">Issue Date</span> up to, <mark class="e_legal-key first last" r="approved">but excluding,</mark> <mark class="e_date first last" r="dd-m-yyyy">28 November 2023</mark> or, if <mark class="e_datelogic first last" r="approved">such day is not</mark> a <span class="dref" dtid="dt680" refersto="Business Day">Business Day</span>, then the next succeeding <span class="dref" dtid="dt680" refersto="Business Day">Business Day</span>, <mark class="e_legal-key first last" r="approved">unless</mark> it would fall in the following month, in which case it <mark class="e_legal-key first last" r="approved">shall be</mark> the <mark class="e_datelogic first last" r="approved">immediately preceding</mark> <span class="dref" dtid="dt680" refersto="Business Day">Business Day</span> (the <mark class="e_crossref first" r="quoted2">"</mark><b><span class="dt" dtfor="Non-Call Period" id="dt190"><mark class="e_crossref" r="quoted2">Non-Call Period</mark></span></b><mark class="e_crossref last" r="quoted2">"</mark>) and <span class="e_inlinenum first last">(ii)</span> in respect of the <span class="dref" dtid="dt625" refersto="Class F Notes">Class F Notes</span>, <mark class="e_datelogic first last" r="approved">from and including</mark> the <span class="dref" dtid="dt31" refersto="Issue Date">Issue Date</span> up to <mark class="e_legal-key first last" r="approved">but excluding</mark> the date designated in any written direction delivered pursuant to <span class="dref" dtid="dt179" refersto="Condition"><mark class="e_crossref first" r="rch">Condition</mark></span><mark class="e_crossref" r="rch"> 2(m) (</mark><i><mark class="e_crossref" r="rch">Sale of </mark><span class="dref" dtid="dt625" refersto="Class F Notes"><mark class="e_crossref" r="rch">Class F Notes</mark></span><mark class="e_crossref" r="rch"> held by the </mark><span class="dref" dtid="dt18" refersto="Issuer"><mark class="e_crossref" r="rch">Issuer</mark></span><mark class="e_crossref last" r="rch">)</mark></i>, the <span class="dref" dtid="dt28" refersto="Debt">Debt</span> <mark class="e_legal-key first last" r="approved">is not</mark> <mark class="e_legal-key first last" r="approved">subject to</mark> <span class="dref" dtid="dt1002" refersto="Optional Redemption">Optional Redemption</span> (<mark class="e_legal-key first last" r="approved">save for</mark> <mark class="e_datelogic first last" r="approved">upon</mark> a <span class="dref" dtid="dt740" refersto="Collateral Tax Event">Collateral Tax Event</span>, a <span class="dref" dtid="dt996" refersto="Note Tax Event">Note Tax Event</span> or a <span class="dref" dtid="dt1143" refersto="Special Redemption">Special Redemption</span>)<span class="e_send first last">.</span> See <span class="dref" dtid="dt179" refersto="Condition"><mark class="e_crossref first" r="rch">Condition</mark></span><mark class="e_crossref" r="rch"> 7 </mark><i><mark class="e_crossref last" r="rch">(Redemption and Purchase)</mark></i>.</p>
            `,
            text: 'Non-Call Period During the period (i) in respect of the Debt (other than the Class F Notes), from and including the Issue Date up to, but excluding, 28 November 2023 or, if such day is not a Business Day, then the next succeeding Business Day, unless it would fall in the following month, in which case it shall be the immediately preceding Business Day (the "Non-Call Period") and (ii) in respect of the Class F Notes, from and including the Issue Date up to but excluding the date designated in any written direction delivered pursuant to Condition 2(m) (Sale of Class F Notes held by the Issuer), the Debt is not subject to Optional Redemption (save for upon a Collateral Tax Event, a Note Tax Event or a Special Redemption).See Condition 7 (Redemption and Purchase).',
            paragraphHeadings: [
              {
                text: 'IMPORTANT NOTICE',
              },
            ],
          },
        ],
      },
    },
    anchors: [
      {
        type: 'deal',
        isKeyAnchor: true,
        snapshot: { displayName: 'AlbaCore Euro CLO IV (2022-05-10)', managerId: 'albacore' },
        link: { routerLink: ['/', 'transactions', 'euclo', 'albacore', 'albacore4'] },
        typeDisplayName: 'Deal',
        visible: true,
      },
      {
        type: 'manager',
        isKeyAnchor: false,
        snapshot: { displayName: 'AlbaCore' },
        link: {
          routerLink: ['/', 'deals', 'filter', 'new'],
          queryParams: { defaultFilters: true, managers: 'albacore' },
        },
        typeDisplayName: 'Manager',
        visible: true,
      },
      {
        type: 'document',
        isKeyAnchor: true,
        snapshot: {
          displayName: 'OC',
        },
        typeDisplayName: 'Document',
        visible: true,
      },
      {
        type: 'heading',
        isKeyAnchor: true,
        snapshot: { displayName: 'IMPORTANT NOTICE' },
        typeDisplayName: 'Heading',
        visible: true,
      },
      {
        type: 'headingBreadcrumb',
        isKeyAnchor: false,
        snapshot: { displayName: 'IMPORTANT NOTICE', breadcrumbs: ['IMPORTANT NOTICE'] },
        typeDisplayName: 'Heading breadcrumb',
        visible: true,
      },
      {
        type: 'sourceReference',
        isKeyAnchor: null,
        snapshot: { displayName: '[1] p1' },
        typeDisplayName: 'Source reference',
        visible: true,
      },
    ],
    contextSource: 'DocumentViewerParagraph',
    numberOfComments: 3,
    hasThread: true,
    assignees: ['lars.bjornsson'],
    firstComment: {
      createdAt: '2023-09-08T15:05:57.475Z',
      channel: null,
      markdown: `How does this non-call period stack up to what we usually see? I'm noticing more of these configurations lately.`,
      html: `How does this non-call period stack up to what we usually see? I'm noticing more of these configurations lately.`,
      sender: 'lars.bjornsson@starkcapital.com',
      senderShort: 'lars.bjornsson',
      sentByMe: true,
    },
    thread: [
      {
        createdAt: '2023-09-12T08:39:03.187Z',
        channel: null,
        markdown: `Spot on. In Semeris' Market Compare, only 10% of the market uses the 'Class F' in the non-call period definition. It's not the norm.`,
        html: `Spot on. In Semeris' Market Compare, only 10% of the market uses the 'Class F' in the non-call period definition. It's not the norm.`,
        sender: 'charlie.stark@starkcapital.com',
        senderShort: 'charlie.stark',
        sentByMe: false,
        labels: [],
      },
      {
        createdAt: '2023-09-12T08:49:25.960Z',
        channel: null,
        markdown:
          'I found a note in Semeris. They did the same thing last year. We were okay with it back then.',
        html: 'I found a note in Semeris. They did the same thing last year. We were okay with it back then.',
        sender: 'sofia.martinez@starkcapital.com',
        senderShort: 'sofia.martinez',
        sentByMe: false,
        labels: [],
      },
    ],
    html: 'DOES NOT',
  } as any,
];
